export default __webpack_public_path__ + "460b063c543a333967d2ddb3f959871a.gif";